import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild } from "../types";

export const getAttribute = (element: ConfigContainerChild, attributes: FeatureAttribute[]) => {
  return Array.isArray(element?.attributeName)
    ? null
    : element?.attributeName
    ? attributes?.find(({ name }) => name === element.attributeName)
    : null;
};
